import { stripBase64Prefix } from './stripBase64Prefix';

export function base64ToBlob(
    base64Data: string,
    mimeType: string = 'application/octet-stream',
    stripPrefix: boolean = true,
): Blob {
    const cleanBase64 = stripPrefix ? stripBase64Prefix(base64Data) : base64Data;

    const binaryString = window.atob(cleanBase64);
    const bytes = new Uint8Array(binaryString.length);

    for (let i = 0; i < binaryString.length; i++) {
        bytes[i] = binaryString.charCodeAt(i);
    }

    return new Blob([bytes], { type: mimeType });
}
